<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="configuracion-formulario" titulo="Formulario / Configuración" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">
            <a id="catalogos" (click)="ctrl.cargarCatalogo('fs_campos_catalogos', 'fs-campo-catalogo');"></a>
            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">
                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="overflow: auto;padding: 1rem !important;height: 85.8vh;">

                  <div class="columns">
                      <div class="column is-12">
                          <div class="field">
                              <label class="label">Nombre:</label>
                              <p class="control has-icons-left has-icons-right">
                                  <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }" placeholder="Nombre"
                                      formControlName="nombre">
                                  <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                                      <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es requerido.</span>
                              </p>
                          </div>
                      </div>
                  </div>

                  <fieldset  formArrayName="formularios_secciones">
                    <legend>Secciones</legend>
                    <div class="card" *ngFor="let item of ctrl.dato.controls.formularios_secciones.controls; let i = index" [formGroupName]="i">
                      <header class="card-header" style="background: gainsboro">
                        <div class="card-header-title" style="font-weight: 200; display: flow-root;">
                          <div style="float:left" >
                            <strong>#{{i + 1}} -> {{item.controls.nombre.value}}</strong>
                          </div>
                          <div style="float:right" >
                            <button type="button" class="button is-danger" (click)="quitar_form_array_seccion(i)">
                              <i class="fa fa-trash-o"></i>
                            </button>
                          </div>
                        </div>
                      </header>
                      <div class="card-content">
                        <div class="content">
                          <div class="columns">
                            <div class="column is-2">
                              <div class="field">
                                <label class="label">Icono:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <input class="input" type="text" [ngClass]="{'is-danger': item.controls.icono.hasError('required')}"
                                    formControlName="icono">
                                  <span class="icon is-small is-right" *ngIf="item.controls.icono.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.icono.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>

                            <div class="column is-4">
                              <div class="field">
                                <label class="label">Nombre:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <input class="input" type="text" [ngClass]="{'is-danger': item.controls.nombre.hasError('required')}"
                                    formControlName="nombre">
                                  <span class="icon is-small is-right" *ngIf="item.controls.nombre.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.nombre.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>

                            <div class="column is-1">
                              <div class="field">
                                <label class="label">Orden:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <input class="input" type="number" [ngClass]="{'is-danger': item.controls.orden.hasError('required')}"
                                    formControlName="orden">
                                  <span class="icon is-small is-right" *ngIf="item.controls.orden.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.orden.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>

                            <div class="column is-2">
                              <div class="field">
                                <label class="label">Orientación:</label>
                                <div class="control has-icons-left has-icons-right">

                                  <ng-select2 [disabled]="orientaciones ? orientaciones.length == 0 ? true : false : true" name="orientacion" [options]="ctrl.optionSelect" [value]="item.controls.orientacion.value" (valueChanged)="ctrl.seleccionarValorSelect2($event, item.controls.orientacion);"
                                    [data]="orientaciones"></ng-select2>

                                  <span class="icon is-small is-right" *ngIf="item.controls.orientacion.hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="item.controls.orientacion.hasError('required') ">Este campo es requerido.</span>
                                </div>
                              </div>
                            </div>

                            <div class="column is-2">
                              <div class="field">
                                <label class="label">Imprimir nombre:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <div class="b-checkbox is-info">
                                    <input type="checkbox" name="imprimir_nombre{{i}}" id="imprimir_nombre{{i}}" [value]="1"  formControlName="imprimir_nombre">
                                    <label for="imprimir_nombre{{i}}">
                                      Si
                                    </label>
                                  </div>

                                </div>
                              </div>
                            </div>

                            <div class="column is-1">
                              <div class="field">
                                <label class="label">Imprimir en PDF:</label>
                                <div class="control has-icons-left has-icons-right">
                                  <div class="b-checkbox is-info">
                                    <input type="checkbox" name="imprimir_en_comprobante{{i}}" id="imprimir_en_comprobante{{i}}" [value]="1" formControlName="imprimir_en_comprobante">
                                    <label for="imprimir_en_comprobante{{i}}">
                                      Si
                                    </label>
                                  </div>

                                </div>
                              </div>
                            </div>

                          </div>
                          <div class="columns" >
                            <div class="column is-12" formArrayName="formularios_secciones_campos">
                              <div class="card" *ngFor="let campo of item.controls.formularios_secciones_campos.controls; let c = index" [formGroupName]="c">
                                <header class="card-header" style="background: rgb(142, 204, 223);">
                                  <div class="card-header-title" style="font-weight: 200; display: flow-root;">
                                    <div style="float:left">
                                      <strong>#{{c + 1}} -> {{campo.controls.descripcion.value}}</strong>
                                    </div>
                                    <div style="float:right">
                                      <button type="button" class="button is-danger" (click)="quitar_form_array_campo(i, c)">
                                        <i class="fa fa-trash-o"></i>
                                      </button>
                                    </div>
                                  </div>
                                </header>
                                <div class="card-content">
                                  <div class="content">
                                    <div class="columns">

                                      <div class="column is-3">
                                        <div class="field">
                                          <label class="label">Campo:</label>
                                          <div class="control has-icons-left has-icons-right">
                                            <input class="input" type="text" [ngClass]="{'is-danger': campo.controls.campo.hasError('required')}"
                                              formControlName="campo">
                                            <span class="icon is-small is-right" *ngIf="campo.controls.campo.hasError('required') ">
                                              <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="campo.controls.campo.hasError('required') ">Este campo es requerido.</span>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="column is-3">
                                        <div class="field">
                                          <label class="label">Tipo:</label>
                                          <div class="control has-icons-left has-icons-right">
                                            <ng-select2 [disabled]="tipos_datos ? tipos_datos.length == 0 ? true : false : true" name="tipo_dato" [options]="ctrl.optionSelect" [value]="campo.controls.tipo_dato.value"
                                              (valueChanged)="ctrl.seleccionarValorSelect2($event, campo.controls.tipo_dato);" [data]="tipos_datos"></ng-select2>
                                            <span class="icon is-small is-right" *ngIf="campo.controls.tipo_dato.hasError('required') ">
                                              <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="campo.controls.tipo_dato.hasError('required') ">Este campo es requerido.</span>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="column is-2">
                                        <div class="field">
                                          <label class="label">Clase:</label>
                                          <div class="control has-icons-left has-icons-right">
                                            <input class="input" type="text" [ngClass]="{'is-danger': campo.controls.clase.hasError('required')}"
                                              formControlName="clase">
                                            <span class="icon is-small is-right" *ngIf="campo.controls.clase.hasError('required') ">
                                              <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="campo.controls.clase.hasError('required') ">Este campo es requerido.</span>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="column is-2">
                                        <div class="field">
                                          <label class="label">Longitud:</label>
                                          <div class="control has-icons-left has-icons-right">
                                            <input class="input" type="text" [ngClass]="{'is-danger': campo.controls.longitud.hasError('required')}"
                                              formControlName="longitud">
                                            <span class="icon is-small is-right" *ngIf="campo.controls.longitud.hasError('required') ">
                                              <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="campo.controls.longitud.hasError('required') ">Este campo es requerido.</span>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="column is-1">
                                        <div class="field">
                                          <label class="label">Orden:</label>
                                          <div class="control has-icons-left has-icons-right">
                                            <input class="input" type="text" [ngClass]="{'is-danger': campo.controls.orden.hasError('required')}"
                                              formControlName="orden">
                                            <span class="icon is-small is-right" *ngIf="campo.controls.orden.hasError('required') ">
                                              <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="campo.controls.orden.hasError('required') ">Este campo es requerido.</span>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="column is-1">
                                        <div class="field">
                                          <label class="label">Imprimir en PDF:</label>
                                          <div class="control has-icons-left has-icons-right">
                                            <div class="b-checkbox is-info">
                                              <input type="checkbox" name="imprimir_en_comprobante{{i}}_{{c}}" id="imprimir_en_comprobante{{i}}_{{c}}" [value]="1" formControlName="imprimir_en_comprobante">
                                              <label for="imprimir_en_comprobante{{i}}_{{c}}">
                                                Si
                                              </label>
                                            </div>

                                          </div>
                                        </div>
                                      </div>


                                    </div>

                                    <div class="columns">
                                      <div class="column is-2">
                                        <div class="field">
                                          <label class="label">Descripción:</label>
                                          <div class="control has-icons-left has-icons-right">
                                            <input class="input" type="text" [ngClass]="{'is-danger': campo.controls.descripcion.hasError('required')}"
                                              formControlName="descripcion">
                                            <span class="icon is-small is-right" *ngIf="campo.controls.descripcion.hasError('required') ">
                                              <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="campo.controls.descripcion.hasError('required') ">Este campo es requerido.</span>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="column is-2">
                                        <div class="field">
                                          <label class="label">Es requerido?:</label>
                                          <div class="control has-icons-left has-icons-right">
                                            <div class="b-checkbox is-info">
                                              <input type="checkbox" name="requerido{{i}}_{{c}}" id="requerido{{i}}_{{c}}" [value]="1" formControlName="requerido">
                                              <label for="requerido{{i}}_{{c}}">
                                                Si
                                              </label>
                                            </div>

                                          </div>
                                        </div>
                                      </div>

                                      <div class="column is-2">
                                        <div class="field">
                                          <label class="label">Es catalogo?:</label>
                                          <div class="control has-icons-left has-icons-right">
                                            <div class="b-checkbox is-info">
                                              <input type="checkbox" name="es_catalogo{{i}}_{{c}}" id="es_catalogo{{i}}_{{c}}" [value]="1" formControlName="es_catalogo">
                                              <label for="es_catalogo{{i}}_{{c}}">
                                                Si
                                              </label>
                                            </div>

                                          </div>
                                        </div>
                                      </div>

                                      <div class="column is-2">
                                        <div class="field">
                                          <label class="label">Catalogo:</label>
                                          <div class="control has-icons-left has-icons-right" *ngIf="campo.controls.es_catalogo.value">
                                            <ng-select2 [disabled]="ctrl.fs_campos_catalogos ? ctrl.fs_campos_catalogos.length == 0 ? true : false : true" name="formularios_secciones_campos_catalogos_id" [options]="ctrl.optionSelect" [value]="campo.controls.formularios_secciones_campos_catalogos_id.value"
                                              (valueChanged)="ctrl.seleccionarValorSelect2($event, campo.controls.formularios_secciones_campos_catalogos_id);" [data]="ctrl.fs_campos_catalogos"></ng-select2>
                                            <span class="icon is-small is-right" *ngIf="campo.controls.formularios_secciones_campos_catalogos_id.hasError('required') ">
                                              <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="campo.controls.formularios_secciones_campos_catalogos_id.hasError('required') ">Este campo es requerido.</span>
                                          </div>
                                        </div>
                                      </div>


                                      <div class="column is-2">
                                        <div class="field">
                                          <label class="label">Es dependiente?:</label>
                                          <div class="control has-icons-left has-icons-right">
                                            <div class="b-checkbox is-info">
                                              <input type="checkbox" name="es_dependiente{{i}}_{{c}}" id="es_dependiente{{i}}_{{c}}" [value]="1" formControlName="es_dependiente">
                                              <label for="es_dependiente{{i}}_{{c}}">
                                                Si
                                              </label>
                                            </div>

                                          </div>
                                        </div>
                                      </div>

                                      <div class="column is-2">
                                        <div class="field">
                                          <label class="label">Campo que depende:</label>
                                          <div class="control has-icons-left has-icons-right" *ngIf="campo.controls.es_dependiente.value">
                                            <input class="input" type="text" [ngClass]="{'is-danger': campo.controls.campo_depende.hasError('required')}"
                                              formControlName="campo_depende">
                                            <span class="icon is-small is-right" *ngIf="campo.controls.campo_depende.hasError('required') ">
                                              <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="campo.controls.campo_depende.hasError('required') ">Este campo es requerido.</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="columns" >
                            <div class="column is-12">
                              <div class="button is-primary is-outlined is-fullwidth" style="background: rgb(142, 204, 223); width:100%; ">
                                <button type="button" class="button is-default" (click)="agregar_form_array_campo(i)">
                                  <i class="fa fa-plus"></i> &nbsp; Agregar
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="button is-primary is-outlined is-fullwidth" style="background: rgba(127, 220, 42, 0.62); width:100%; ">
                      <button type="button" class="button is-default" (click)="agregar_form_array_seccion()">
                        <i class="fa fa-plus"></i> &nbsp; Agregar
                      </button>
                    </div>

                  </fieldset>

                </section>
            </form>
        </div>
    </div>
</div>

